import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  CreateCompanyWarehouseActions as Actions,
  CreateCompanyWarehouseRequestAction as RequestAction,
} from 'store/ducks/companyWarehouses';

export function* createCompanyWarehouseRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, `company-warehouses`, postData);
    onSuccess && onSuccess();
    notify('success', 'Armazém vinculado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
